import { StyleSheet } from '@react-pdf/renderer'
import { theme } from '../../theme/theme'

export const styles = StyleSheet.create({
  /* PAGE */
  page: {
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    padding: 40,
  },

  /* CONTAINERS */
  headerContainer: {
    marginBottom: 15,
  },
  logoContainer: {
    alignItems: 'flex-end',
    marginBottom: 20,
  },
  flexContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  mYcontainer: {
    marginVertical: 10,
  },
  mYmediumContainer: {
    marginVertical: 20,
  },
  cardContainer: {
    padding: 10,
    borderRadius: 5,
    backgroundColor: theme.colors.brand.extraLightGrayBg,
    marginBottom: 10,
  },
  commentsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 20,
  },
  smallWidthContainer: {
    width: '20%',
  },
  largeWidthContainer: {
    width: '80%',
  },

  /* IMAGES */
  logo: {
    width: 120,
  },

  /* TEXT */
  title: {
    fontSize: 18,
    marginBottom: 5,
    fontWeight: 'bold',
    color: theme.colors.purple[400],
  },
  subtitle: {
    fontSize: 12,
    color: theme.colors.purple[300],
  },
  extraSmallTextItalic: {
    fontSize: 8,
    fontStyle: 'italic',
  },
  smallText: {
    fontSize: 10,
  },
  underlineText: {
    textDecoration: 'underline',
  },
  text: {
    fontSize: 11,
  },
  boldText: {
    fontWeight: 'bold',
  },
  lightGrayText: {
    fontSize: 11,
    color: theme.colors.brand.lightGrayText,
  },

  /* MARGINS */
  smallMr: {
    marginRight: 5,
  },
  mediumMt: {
    marginTop: 15,
  },
  smallMb: {
    marginBottom: 5,
  },
  mediumMb: {
    marginBottom: 10,
  },

  /* DIVIDERS */
  leftBorder: {
    borderLeftWidth: 2,
    borderLeftColor: theme.colors.purple[200],
    paddingLeft: 10,
  },
  divider: {
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.brand.lightGrayBorder,
    marginTop: 4,
    marginBottom: 10,
    width: '100%',
  },

  /*  GRIDS */
  gridContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginVertical: 10,
  },
  gridItemForFive: {
    width: '16%',
    margin: 2,
    borderRadius: 4,
  },
  largeGridItem: {
    width: '70%',
    marginLeft: 5,
  },
  thinGridItem: {
    width: '20%',
    marginRight: 5,
  },

  /* TABLE */
  table: {
    display: 'flex',
    width: 'auto',
    borderTop: '1px solid #ccc',
    marginBottom: 10,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#dddddd',
    borderBottomStyle: 'solid',
    minHeight: 24,
    fontSize: 9,
  },
  headerRow: {
    backgroundColor: '#f2f2f2',
  },
  tableCell: {
    flex: 1,
    padding: 5,
  },
  headerCell: {
    fontWeight: 'bold',
  },
  tableCaption: {
    fontSize: 8,
    textAlign: 'center',
    marginTop: 2,
    fontWeight: 'bold',
  },

  /* STATS */
  reportStatCard: {
    borderLeftWidth: 4,
    width: '30%',
  },
})
